<template>
  <el-switch :disabled="!toggleState" @change="change" v-model="toggleState"></el-switch>
</template>

<script>
export default {
  data() {
    return {
      toggleState: false
    }
  },
  beforeMount() {
    this.toggleState = (this.params.data.featureState === 1)
  },
  methods: {
    change(val) {
      val = (val)? 1 : 0
      let params = {
        data: {
          value: val,
          id: this.params.data.id
        }
      }      
      this.params.props.updateField(params, val, () => {}, 'featureState')
    }
  }
}
</script>
